import React from "react";
import CharchaCard from "../../AllEpisode/AllEpisode_Components/CharchaCard";
import Emp_Card from "../../Empowering/emp_components/EmpCard";
import ReelCard from "../../Empowering/emp_components/ReelCard";

const ShortReelVideo = ({
  episodeData,
  handleclick,
  isShortReel,
  handleShareData,
  sharetext,
}) => {
  // console.log(episodeData);
  const shortsData = episodeData?.parikshadata?.shorts;
  return (
    <>
      <section className="charcha_sec charcha_sec_pad_reel">
        <img src="/assets/images/wings.png" className="wing_img_pos" alt="" />
        <div className="container-fluid">
          <div className="episode_banner_pad episode_banner_pad_pos">
            <ul className="eae_list">
              {
                <li>
                  {episodeData && (
                    <Emp_Card
                      episode={episodeData}
                      handleShareData={handleShareData}
                    />
                  )}
                </li>
              }
            </ul>
            <div className="row_mar_pad vremove_num">
              <div className="row">
                {shortsData?.map((short, index) => (
                  <div className="col-sm-3" key={index}>
                    <div className="charchcard_bgchange">
                      <ReelCard
                        reel={short}
                        handleclick={handleclick}
                        isShortReel={isShortReel}
                        handleShareData={handleShareData}
                        sharetext={sharetext}
                        shortsData={shortsData}
                        index={index}
                        indexforslide={index}
                        type="shorts"
                      />
                    </div>
                  </div>
                ))}
              </div>

              {/* <div className="col-sm-12">
                <button className="loadmore_btn">Load More</button>
              </div> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ShortReelVideo;
